import './history.scss';
import {PageManager} from '@mvps-genesis/core';
import AOS from 'aos';
// Slick Slider 1.7.1
import 'slick-carousel';

/* eslint-disable max-lines-per-function, no-console, max-params */

export default class history extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {

		const self = this;

		self.lazyLoadImages();
		self.historyPage();

	}


	historyPage () {
		const self = this;

		AOS.init({
			disable: 'mobile'
		});

		/**
		 * Summary:
		 * Timeline component contains 2 sub components.
		 * 'Decades': This component will be a start of a decade E.G. 1900 that
		 * will contain years within that decade E.G. 1901, 1902, 1903...
		 * 'Years': This component will be a year that will represent a slide within the slider. Years
		 * will contain the information of its decade.
		 *
		 * Hierarchy:
		 * Decade
		 * |__ Years
		 *
		 * Functionality:
		 * - Interacting with a decade will set the year that starts that decade as the current
		 * slide.
		 * - Slider dots represent all of the years that belong to the decade we are currently in. Upon
		 * changing the slide those dots will be either shown or hidden depdending on which decade we are
		 * in
		 * @return {undefined}
		 */
		const historyTimeLine = function () {
			// CONSTANTS
			var CURRENT_DECADE_SELECTED_CLASS = "selected";
			var HIDE_IMPORTANT_CLASS = "hide-subs";
			var DATA_YEAR_START = "yearStart";
			var DATA_YEAR_END = "yearEnd";

			// DOM
			var $timeline = $(".history_timeline-items");
			var $decades = $(".history_timeline-decades");
			var $decadesChildren = $decades.children();
			var $decadeButtons = $(".history_timeline_decade-button");

			// Runtime

			/**
			 * Decade button will return the year that starts
			 * the decade and will set that year as the current slide
			 * @return {undefined}
			 */
			$decadeButtons.on("click", function () {
				var $this = $(this);
				var $currentDecade = $this.parents(".history_timeline-decade");
				var currentDecadeYearStart = $currentDecade.data(DATA_YEAR_START);

				$timeline.slick("slickGoTo", currentDecadeYearStart, false);
			});

			// Events

			/**
			 * Will select the first decade and add the selected class. Based off
			 * the current decade we will update the dots to show or hide them as needed.
			 * @param  {Event<Object>} event
			 * @param  {Slick<Object>} slick
			 * @return {undefined}
			 */
			$timeline.on("init", function (event, slick) {
				var $slickDots = $(".slick-dots");
				var $currentSlide = $(slick.$slides[slick.currentSlide]);
				var $currentSlideDecadeIndex = $currentSlide.data("decadeIndex");
				var $currentDecadeYearsCount = $currentSlide.data("yearsCount");
				var $currentDecade = $decadesChildren.eq($currentSlideDecadeIndex);
				var currentDecadeYearStart = $currentDecade.data(DATA_YEAR_START);
				var currentDecadeYearEnd = $currentDecade.data(DATA_YEAR_END);



				// AOS REFRESH
				AOS.refresh();

				// Add Selected
				$currentDecade.addClass(CURRENT_DECADE_SELECTED_CLASS);

				/**
				 * Show dots if there's more than 1
				 */
				if (parseInt($currentDecadeYearsCount) > 1) {
					$slickDots.show();
				} else {
					$slickDots.hide();
				}

				/**
				 * Display the active dots
				 * @param  {Number} index
				 * @return {undefined}
				 */
				$slickDots.children().each(function (index) {
					var $this = $(this);

					/**
					 * Exit early if the current slide is
					 * between the start and end date
					 */

					if (index >= currentDecadeYearStart && index <= currentDecadeYearEnd) {
						return;
					};

					// Hide Dot
					$this.addClass(HIDE_IMPORTANT_CLASS);
				});
			});

			/** On after slide changes we will select the first decade and add the selected
			 * class.Based off the current decade we will update the dots to show or hide
			 * them as needed.
			 * @param  {Event<Object>} event
			 * @param  {Slick<Object>} slick
			 */
			$timeline.on("afterChange", function (event, slick) {
				var $currentSlide = $(slick.$slides[slick.currentSlide]);
				var $currentSlideDecadeIndex = $currentSlide.data("decadeIndex");
				var $currentDecadeYearsCount = $currentSlide.data("yearsCount");
				var $currentDecade = $decadesChildren.eq($currentSlideDecadeIndex);
				var currentDecadeYearStart = $currentDecade.data(DATA_YEAR_START);
				var currentDecadeYearEnd = $currentDecade.data(DATA_YEAR_END);

				var $slickDots;



				// Exit early if the current decade has the selected class
				if ($currentDecade.hasClass(CURRENT_DECADE_SELECTED_CLASS)) return;

				// Entered a new decade. Remove the previously selected decade
				$decades.children('.' + CURRENT_DECADE_SELECTED_CLASS).removeClass(CURRENT_DECADE_SELECTED_CLASS);

				// Set the new current decade
				$currentDecade.addClass(CURRENT_DECADE_SELECTED_CLASS);


				var decadeLocation = $decades.find('.' + CURRENT_DECADE_SELECTED_CLASS).offset().left;

				$decades.animate({
					scrollLeft: decadeLocation
				}, 250);

				// Return the dot's container
				$slickDots = $(".slick-dots");

				/**
				 * Display the active dots or hide inactive dots
				 * @param  {Number} index
				 * @return {undefined}
				 */

				/**
				 * Show dots if there's more than 1
				 */
				if (parseInt($currentDecadeYearsCount) > 1) {
					$slickDots.show();
				} else {
					$slickDots.hide();
				}

				$slickDots.children().each(function (index) {
					var $this = $(this);

					/**
					 * Exit early if the current slide is between the start
				 	 * and end date and has the hidden class
					*/ 

					if (index >= currentDecadeYearStart && index <= currentDecadeYearEnd && $this.hasClass(HIDE_IMPORTANT_CLASS)) {
						$this.removeClass(HIDE_IMPORTANT_CLASS);
						return;
					};

					// Hide Dot
					$this.addClass(HIDE_IMPORTANT_CLASS);
				});

			});

			// Init Slick
			$timeline.slick({
				arrows: true,
				dots: true,
				infinite: false,
				responsive: [{
					breakpoint: 1024,
					settings: {
						arrows: false
					}
				}],
				slidesToScroll: 1,
				slidesToShow: 1
			});
		};
		// History Advertising
		const historyAdvertising = function () {
			$('.is-advertisement-slider').slick({
				arrows: true,
				dots: false,
				infinite: true,
				responsive: [{
					breakpoint: 1280,
					settings: {
						arrows: true,
						dots: false,
						slidesToScroll: 1,
						slidesToShow: 3
					}
				},
				{
					breakpoint: 900,
					settings: {
						arrows: true,
						dots: false,
						slidesToScroll: 1,
						slidesToShow: 2
					}
				},
				{
					breakpoint: 650,
					settings: {
						arrows: false,
						slidesToScroll: 1,
						slidesToShow: 1,
						infinite: false,
						centerMode: true
					}
				}
				],
				slidesToScroll: 1,
				slidesToShow: 5
			});

		};

		historyTimeLine();
		historyAdvertising();

		self.heroVideo();
	}

	heroVideo () {
		var $heroVideoButton = $("#heroVideo__button");

		// Click evenet handler
		$heroVideoButton.on('click', function () {
			var heroVideoURL = window.mivaJS.historyPage.heroVideo.url || "";

			// If no URL was passed through. Disable the video button
			if (heroVideoURL.trim() === "") {
				$heroVideoButton.off("click");
				$heroVideoButton.prop("disabled", true);
				return;
			}

			$.magnificPopup.open({
				items: [{
					src: heroVideoURL,
					type: 'iframe'
				}],
				type: 'iframe',
				iframe: {
					markup: '<div class="mfp-iframe-scaler">' + '<div class="mfp-close"></div>' + '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' + '</div>',
					patterns: {
						youtube: {
							index: 'youtube.com/',
							id: 'v=',
							src: '//www.youtube.com/embed/%id%?rel=0&controls=0'
						},
						vimeo: {
							index: 'vimeo.com/',
							id: '/',
							src: '//player.vimeo.com/video/%id%?autoplay=1'
						}
					},
					srcAction: 'iframe_src',
				}
			})
		});
	}

	lazyLoadImages () {

		(function (window, document, mivaJS) {

			mivaJS.mmLazyLoadImgBgs = function (bgs) {
				var _t = this;
				_t.mmObserverBgImgs;
				if (mivaJS._hasIntObsrvr == true) {
					_t.mmObserverBgImgs = new IntersectionObserver(function (entries) {
						entries.map(function (item, i) {
							if (item.intersectionRatio > 0) {
								var bg = item.target;
								_t.apply(i, bg, bg._delay);
								///remove observe
								_t.mmObserverBgImgs.unobserve(item.target);
							}
						});
					}, {
						rootMargin: '25px 0px',
						threshold: 0.01
					});
				}
				if (bgs.length > 0) {
					for (var i = 0; i < bgs.length; i++) {
						var bg = bgs[i];
						bg.img = new Image();
						bg._delay = 0;
						if ('timeout' in bg.dataset) {
							bg._delay = parseInt(bg.dataset.timeout);
						}
						if (mivaJS._hasIntObsrvr == true) {
							_t.mmObserverBgImgs.observe(bg);
						} else {
							_t.apply(i, bg, bg._delay);
						}
					}
				}
			};
			mivaJS.mmLazyLoadImgBgs.prototype.apply = function (i, bg, delay) {
				if (bg.className.search(/is--loaded/i) == -1) {
					bg.img.onload = function () {
						var t = this;
						if (t.height > t.width) {
							bg.classList.add('img--tall');
						} else if (t.height < t.width) {
							bg.classList.add('img--wide');
						} else {
							bg.classList.add('img--square');
						}
						var loadDelay = bg.getAttribute('data-delay');
						bg.style.backgroundImage = 'url("' + bg.dataset.srcBg + '")';
						if (loadDelay) {
							bg.style.transitionDelay = loadDelay + 's';
						}
						bg.classList.add('is--loaded');
					};
					bg._timeout = setTimeout(function () {
						bg.img.src = bg.dataset.srcBg;
					}, delay);
				}
			};
			// Lazy IMAGES
			mivaJS.mmLazyLoadImgs = function (imgs, options, callback) {
				if (typeof options != 'object') {
					options = {
						src: 'src'
					};
				}
				var _t = this;
				_t.mmObserverImgs;
				if (mivaJS._hasIntObsrvr == true) {
					_t.mmObserverImgs = new IntersectionObserver(function (entries) {
						entries.map(function (item, i) {
							if (item.intersectionRatio > 0) {
								var img = item.target;
								// Load my image
								_t.apply(i, img, img._delay, options, callback);
								// Remove observe
								_t.mmObserverImgs.unobserve(item.target);
							}
						});
					}, {
						rootMargin: '25px 0px',
						threshold: 0.01
					});
				}
				if (imgs.length > 0) {
					for (var i = 0; i < imgs.length; i++) {
						var img = imgs[i];
						img._delay = 0;
						if ('timeout' in img.dataset) {
							img._delay = parseInt(img.dataset.timeout, 10);
						}
						if (mivaJS._hasIntObsrvr == true) {
							_t.mmObserverImgs.observe(img);
						} else {
							_t.apply(i, img, img._delay, options, callback);
						}
					}
				}
			}
			mivaJS.mmLazyLoadImgs.prototype.apply = function (i, img, delay, options, callback) {
				if (img.className.search(/lazyimg-ignore/i) === -1) {
					if (img.className.search(/is--loaded/i) === -1) {
						img.onload = function () {
							var t = this;
							if (t.height > t.width) {
								t.classList.add('img--tall');
							} else if (t.height < t.width) {
								t.classList.add('img--wide');
							} else {
								t.classList.add('img--wide');
							}
							t.classList.add('is--loaded');
						};
						img.mmTimeout = setTimeout(function () {
							var imgsrc = img.dataset[options.src];
							img.src = imgsrc;
							img.classList.add('is__loaded');
							if (typeof callback === 'function') {
								callback(img, imgsrc);
							}
						}, delay);
					}
				}
			};
			// Load images
			const __loadLazyImages = function () {
				window.mmGlobalBackgroundImages = new mivaJS.mmLazyLoadImgBgs(document.querySelectorAll('[data-src-bg]'));
				window.mmGlobalImages = new mivaJS.mmLazyLoadImgs(document.querySelectorAll('[data-src]'));
			};
			if (window.addEventListener) {
				window.addEventListener('load', __loadLazyImages);
			} else {
				window.attachEvent('onload', __loadLazyImages);
			}
		}(window, document, window.mivaJS || (window.mivaJS = {})));
	}

}
